import Drawer from '@mui/material/Drawer';

import NavigationList from '../../../../infra/navigation/navigation-list';

export type MobileSidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};

const MobileSidebar = ({ isOpen, onClose }: MobileSidebarProps) => {
  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={isOpen}
      ModalProps={{
        BackdropProps: {
          onClick: onClose
        }
      }}
    >
      <NavigationList />
    </Drawer>
  );
};

export default MobileSidebar;
